export const VossProductClassification = {
    Standard: 0,
    RevenueCarrier: 1
}

export const VossProductClassificationText = {
    [VossProductClassification.Standard]: "vossProductClassification.standard",
    [VossProductClassification.RevenueCarrier]: "vossProductClassification.revenueCarrier"
}
